import React, { useState, useEffect } from "react";
import Axios from "../config/AxiosConfig";
import { Chart } from "react-google-charts";

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const response = await Axios.get("super-admin/dashboard");
      setDashboardData(response.data);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
    setLoading(false);
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="dashboard-content">
      <div className="summary-cards">
        <div className="card">
          <h3>Total Restaurants</h3>
          <p>{dashboardData?.totalRestaurants || 0}</p>
        </div>
        <div className="card">
          <h3>Total Users</h3>
          <p>{dashboardData?.totalUsers || 0}</p>
        </div>
        <div className="card">
          <h3>Total Revenue</h3>
          <p>&#8377;{dashboardData?.totalRevenue || 0}</p>
        </div>
        <div className="card">
          <h3>Total Premium Restaurants</h3>
          <p>{dashboardData?.totalPremiumRestaurants || 0}</p>
        </div>
        <div className="card">
          <h3>Old Users</h3>
          <p>{dashboardData?.oldUsers || 0}</p>
        </div>
        <div className="card">
          <h3>New Users</h3>
          <p>{dashboardData?.newUsers || 0}</p>
        </div>
        <div className="card">
          <h3>Old Restaurants</h3>
          <p>{dashboardData?.oldRestaurants || 0}</p>
        </div>
        <div className="card">
          <h3>New Restaurants</h3>
          <p>{dashboardData?.newRestaurants || 0}</p>
        </div>
      </div>

      {/* 📈 Charts */}
      <div className="charts-container">
        <div className="chart-box">
          <h3>Users Growth</h3>
          <Chart
            chartType="PieChart"
            data={[
              ["Category", "Count"],
              ["New Users", dashboardData?.newUsers || 0],
              ["Old Users", dashboardData?.oldUsers || 0],
            ]}
            options={{
              title: "New vs Old Users",
              pieHole: 0.4,
            }}
            width="100%"
            height="300px"
          />
        </div>

        <div className="chart-box">
          <h3>Restaurants Growth</h3>
          <Chart
            chartType="PieChart"
            data={[
              ["Category", "Count"],
              ["New Restaurants", dashboardData?.newRestaurants || 0],
              ["Old Restaurants", dashboardData?.oldRestaurants || 0],
              ["New Premium Restaurants", dashboardData?.newPremiumRestaurants || 0],
              ["Old Premium Restaurants", dashboardData?.oldPremiumRestaurants || 0],
            ]}
            options={{
              title: "New vs Old Restaurants (Including Premium)",
              pieHole: 0.4,
              colors: ["#FF8C00", "#D2691E", "#4CAF50", "#1E88E5"],
            }}
            width="100%"
            height="300px"
          />
        </div>

        <div className="chart-box">
          <h3>Revenue Statistics</h3>
          <Chart
            chartType="BarChart"
            data={[
              ["Category", "Revenue"],
              ["Total Revenue", dashboardData?.totalRevenue || 0],
            ]}
            options={{
              title: "Revenue Overview",
              hAxis: { title: "Category" },
              vAxis: { title: "Amount (₹)" },
            }}
            width="100%"
            height="300px"
          />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
